import React from 'react';
import { cn } from '@/utils/common_functions';
import { Text } from '../Text';

interface CheckboxProps {
  label?: string | React.ReactNode;
  onChange: (checked: boolean) => void;
  checked: boolean;
  disabled?: boolean;
  className?: string;
  labelClassName?: string;
  inputClassName?: string;
  iconClassName?: string;
  gradient?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = props => {
  const {label, onChange, checked, disabled=false, className, labelClassName, inputClassName, gradient} = props;
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {gradient ? (
        <div
          onClick={() => !disabled && onChange(!checked)}
          className={cn(
            'size-5 rounded-md flex items-center justify-center cursor-pointer flex-shrink-0 border-2 transition-all',
            checked ? 'bg-gradient-to-br from-ui_blue to-ui_blue_light border-transparent' : 'bg-white border-ui_blue/40',
            disabled && 'cursor-not-allowed opacity-50',
            inputClassName,
          )}>
          {checked && (
            <svg viewBox="0 0 10 8" fill="none" className="size-3">
              <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          )}
        </div>
      ) : (
        <input className={cn("size-4 cursor-pointer accent-ui_blue", disabled && 'cursor-not-allowed', inputClassName)} type="checkbox" onChange={e => onChange(e.target.checked)} checked={checked} disabled={disabled} />
      )}
      {label && <Text variant="body" className={cn("text-ui_blue", labelClassName)}>{label}</Text>}
    </div>
  );
};